module.exports = __webpack_public_path__ + "img/mobile-ribbon-right.1b23c090.webp";